module.exports = __webpack_public_path__ + "img/icon-copy-id.c2af47b7.svg";